import React from "react";

function LightBulbSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.036"
      height="36.452"
      viewBox="0 0 26.036 36.452"
    >
      <path
        id="circle1066-3"
        d="M14.6,289.062a13.2,13.2,0,0,0-6.508,24.582v3.347h1.934v.421a1.019,1.019,0,0,0,0,1.985v.552a1.019,1.019,0,0,0,0,1.985v2.3h.916l-.012.067s.058.36.059.361l.134.254s.251.251.255.254.132.07.177.092a.965.965,0,0,0,.1.044,1.973,1.973,0,0,0,.33.079c.192.03.393.052.652.075.518.039,1.2.049,1.961.049s1.443-.01,1.961-.049a6.379,6.379,0,0,0,.668-.075,1.712,1.712,0,0,0,.31-.079.558.558,0,0,0,.118-.044c.045-.025.176-.088.181-.092s.249-.251.252-.254l.134-.254s.059-.36.059-.361-.008-.044-.012-.067h.92v-2.287a1.018,1.018,0,0,0,0-2.013v-.524a1.018,1.018,0,0,0,0-2.009v-.413h1.93v-3.363a13.195,13.195,0,0,0-6.52-24.566Zm0,2.041a11.128,11.128,0,0,1,11.02,11.257,11.269,11.269,0,0,1-5.97,9.994l-.55.286v2.311h-9V312.64l-.538-.286a11.273,11.273,0,0,1-5.97-9.993A11.118,11.118,0,0,1,14.6,291.1Zm-.016,8.271a1.012,1.012,0,0,0-.979,1.034v8.918a1.02,1.02,0,0,0,.473.956,1,1,0,0,0,1.058,0,1.02,1.02,0,0,0,.473-.956v-8.918a1.022,1.022,0,0,0-.3-.737,1,1,0,0,0-.73-.3Zm-6.539,2.7a.935.935,0,0,0-.1,0,1,1,0,0,0-.8.535,1.026,1.026,0,0,0,.006.966l4.087,7.893a1,1,0,0,0,1.77.1,1.026,1.026,0,0,0,.01-1.043L8.941,302.63a1,1,0,0,0-.9-.56Zm12.792,0a1,1,0,0,0-.861.556l-4.083,7.894a1.033,1.033,0,0,0,.02,1.045,1.008,1.008,0,0,0,1.776-.1l4.068-7.894a1.026,1.026,0,0,0-.03-1.019,1,1,0,0,0-.89-.48Zm-8.807,14.92h5.152v.405H12.029Zm0,2.43h5.152v.512H12.029Zm0,2.537h5.152v.254H12.029Z"
        transform="translate(-1.588 -289.062)"
        // fill="#fff"
      />
    </svg>
  );
}

export default LightBulbSvg;
